import { API_USER_SERVICE } from "../config/Constants";
import { ICreateOrderDTO, IMarkItemPackedRequestDTO, IMarkItemPickedRequestDTO } from "../interfaces/Orders";
import { getRequest, postRequest, putRequest } from "./Rest";

export const getWarehouseTypes = async (warehouseId:number) => {
    const path = `${API_USER_SERVICE}/item-type/${warehouseId}/types`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getWarehouseCategories = async (typeId:number) => {
    const path = `${API_USER_SERVICE}/category/${typeId}/categories`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getWarehouseItems = async (categoryId:number) => {
    const path = `${API_USER_SERVICE}/item/${categoryId}/items`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getInventoryItem = async(typeId:number,catId:number,itemId:number) =>{
    const path = `${API_USER_SERVICE}/inventory/quantity?typeId=${typeId}&categoryId=${catId}&itemId=${itemId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};
export const getWarehousePincodes = async() =>{
    const path = `${API_USER_SERVICE}/delivery-pincodes`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
}
export const getWarehousePincodesPublic = async(companyId:number) =>{
    const path = `${API_USER_SERVICE}/delivery-pincodes/${companyId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
}

export const getWarehouseByCompanyId = async(companyId:number) =>{
    const path = `${API_USER_SERVICE}/warehouse/company/${companyId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
}

export const addOrder = async(dto:ICreateOrderDTO) =>{
    const path = `${API_USER_SERVICE}/orders`;
    const response = await postRequest(path,dto);
    return response;
};
export const getOrdersList = async(companyId:number, orderId?:number, statuses?:string[], deliveryDateFrom?:string, deliveryDateTo?:string, pincodes?:string[], minCost?:string, maxCost?:string) =>{
    let path = `${API_USER_SERVICE}/orders?companyId=${companyId}`;
    if (orderId) path += `&orderId=${orderId}`;
    if (statuses?.length) statuses.forEach(s => path += `&statuses=${s}`);
    if (deliveryDateFrom) path += `&deliveryDateFrom=${deliveryDateFrom}`;
    if (deliveryDateTo) path += `&deliveryDateTo=${deliveryDateTo}`;
    if (pincodes?.length) pincodes.forEach(p => path += `&pincodes=${p}`);
    if (minCost) path += `&minCost=${minCost}`;
    if (maxCost) path += `&maxCost=${maxCost}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const searchOrder = async(searchKey:string) =>{
    const path = `${API_USER_SERVICE}/orders?searchKeyword=${searchKey}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const getOrder = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const updateOrder = async(dto:ICreateOrderDTO, orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getPickOrderDetails = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/picking-details`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const scanBarCode = async(orderId:number,dto:IMarkItemPickedRequestDTO) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/pick-item`;
    const response = await putRequest(path, dto);
    return response;
};
export const pickorder = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/complete-picking`;
    const response = await putRequest(path,{});
    return response;
};
export const getViewOrder = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/view`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const getPackageOrderDetails = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/packing-page`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return dataResponse;
};
export const scanPackBarCode = async(orderId:number,dto:IMarkItemPackedRequestDTO) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/pack-item`;
    const response = await putRequest(path, dto);
    return response;
};
export const packorder = async(orderId:number) =>{
    const path = `${API_USER_SERVICE}/orders/${orderId}/complete-packing`;
    const response = await putRequest(path,{});
    return response;
};